import React, { useEffect } from 'react';
import '../StylesComponents/LegalPages.css';

function ContactUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-container">
      <div className="legal-content-wrapper">
        <header className="legal-header">
          <div className="legal-id-badge">SUPPORT_COMM_TERMINAL_v4.0</div>
          <h1 className="legal-title">Contact Us</h1>
          <div className="legal-meta">
            <span>AVAILABILITY: 24/7_DIGITAL</span>
            <span>LOCATION: PERTH_WESTERN_AUSTRALIA</span>
            <span>SECURE_ENCRYPTION: ACTIVE</span>
          </div>
        </header>

        <section className="legal-section">
          <h2>01. General Inquiries</h2>
          <p className="legal-text">
            For all platform-related questions, brand partnerships, or technical feedback, please transmit your correspondence to our primary support node:
          </p>
          <div style={{ padding: '20px', background: '#0a0a0a', border: '1px solid #222', display: 'inline-block' }}>
            <span style={{ fontSize: '18px', fontWeight: '900', color: 'var(--color-savings)', fontFamily: 'monospace' }}>
              jayden@curatedcollective.co
            </span>
          </div>
        </section>

        <section className="legal-section">
          <h2>02. Retailer Onboarding</h2>
          <p className="legal-text">
            Are you an Australian boutique or brand looking to integrate with our API Nexus? Contact our merchandising team at:
          </p>
          <div style={{ padding: '20px', background: '#0a0a0a', border: '1px solid #222', display: 'inline-block' }}>
            <span style={{ fontSize: '18px', fontWeight: '900', color: '#fff', fontFamily: 'monospace' }}>
              jayden@curatedcollective.co
            </span>
          </div>
        </section>

        <section className="legal-section">
          <h2>03. Physical Headquarters</h2>
          <p className="legal-text">
            Stockroom is proudly headquartered in the Western Australian technology corridor.
          </p>
          <ul className="legal-list">
            <li><strong>REGION:</strong> Perth, WA</li>
            <li><strong>JURISDICTION:</strong> Australia (AU)</li>
          </ul>
        </section>

        <footer style={{ marginTop: '80px', padding: '40px 0', borderTop: '1px solid #111', color: '#444', fontSize: '10px', fontFamily: 'monospace' }}>
          END_OF_TRANSMISSION // SUPPORT_PROTOCOL_TERMINATED
        </footer>
      </div>
    </div>
  );
}

export default ContactUs;
